import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IAgreementListFilterRaw } from '../interfaces/IAgreementListFilterRaw';
import { IAgreementListFilterParams } from '../interfaces/IAgreementListFilterParams';
import { IAgreementIndexPage } from '../interfaces/IAgreementIndexPage';

export async function fetchAgreementFilters(): Promise<IFilterResult[]> {
  return apiGet<IFilterResult[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/agreement`);
}

export async function fetchAgreementFilterById(id: number): Promise<IAgreementListFilterRaw> {
  return apiGet<IAgreementListFilterRaw>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/agreement/${id}`);
}

export async function createAgreementFilter(data: IAgreementListFilterRaw): Promise<IFilterResult> {
  return apiPost<IFilterResult>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/agreement`,
    body: data,
  });
}

export async function updateAgreementFilter(id: number, data: IAgreementListFilterRaw): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/agreement/${id}`, data);
}

export async function deleteAgreementFilter(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/${id}`);
}

export async function fetchAgreementFindIndex(
  page: number,
  size: number,
  filter: IAgreementListFilterParams | null,
  order?: string,
): Promise<IAgreementIndexPage> {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('size', String(size));
  if (order) {
    params.append('order', order);
  }

  return apiPost<IAgreementIndexPage>({
    url: `${getServiceBaseURL(APIServiceEnum.INDEX_SERVICE)}/agreement/find-indexes?${params}`,
    body: filter,
  });
}
